import { render } from "./footer-component.vue?vue&type=template&id=70731563&scoped=true"
import script from "./footer-component.vue?vue&type=script&lang=js"
export * from "./footer-component.vue?vue&type=script&lang=js"

import "./footer-component.vue?vue&type=style&index=0&id=70731563&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70731563"]])

export default __exports__